import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { prescreenEndpoints } from '@/modules/prescreen/constants';
import type { paths } from '@/types/apiSchema';

type SessionParams =
  paths['/prescreening/{candidateJobId}/session']['post']['parameters']['path'];

export const useCreateScreeningSessionMutation = () =>
  useMutation({
    mutationFn: async (params: SessionParams) => {
      const { data } = await fetchClient.POST(prescreenEndpoints.session, {
        params: { path: params },
      });
      if (!data?.signedUrl)
        throw new Error('Interview authorization is unavailable.');
      return data.signedUrl;
    },
    // Each successful authorization consumes a call. Only an explicit user retry may request another.
    retry: false,
    gcTime: 0,
  });
